function haystack(company) {
  return [company.name, company.location, company.region, company.domain]
    .join(" ")
    .toLowerCase()
}

export function findAuditMatches(query, companies) {
  const parts = String(query)
    .split(/[/,]/)
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean)

  if (parts.length === 0) return []

  return companies.filter((company) =>
    parts.every((part) => haystack(company).includes(part))
  )
}
